module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The clock did not create an interest in time measurement; the interest in time measurement led to the invention of the clock.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("—David Landes, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Revolution in Time")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 63
// module chunks = 0